import { BooleanFilter } from "components/NewAdvancedSearch/filters/BooleanFilter";
import { DateFilter } from "components/NewAdvancedSearch/filters/DateFilter";
import { GridFilter } from "components/NewAdvancedSearch/filters/GridFilter";
import { ListFilterEditor } from "components/NewAdvancedSearch/filters/ListFilterEditor";
import { RangeFilter } from "components/NewAdvancedSearch/filters/RangeFilter";
import { SelectFilter } from "components/NewAdvancedSearch/filters/SelectFilter";
import { TagFilter } from "components/NewAdvancedSearch/filters/TagFilter";
import { TextFilter } from "components/NewAdvancedSearch/filters/TextFilter";

const VALUE_EDITORS = {
  input: TextFilter,
  select: SelectFilter,
  ruvixxSelect: SelectFilter,
  dateRange: DateFilter,
  ruvixxToggle: BooleanFilter,
  range: RangeFilter,
  tag: TagFilter,
  grid: GridFilter,
  listFilter: ListFilterEditor,
};

export function ValueEditor({ descriptor, value, onChange }) {
  const Editor = VALUE_EDITORS[descriptor.type] ?? TextFilter;
  return <Editor descriptor={descriptor} value={value} onChange={onChange} />;
}
